import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { useContext } from 'react';
import { useScopedTranslations } from 'pricing-pages-ui-components/i18n/useScopedTranslations';
import errorFallbackTranslations from 'i2l?query=sporks!../../../lang/errorFallback/en.lyaml';
import { PublicI18nContext } from '../../context/I18nContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicAppErrorFallback = () => {
  const {
    i18nLoader
  } = useContext(PublicI18nContext);
  const T = useScopedTranslations(errorFallbackTranslations, i18nLoader);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    padding: "1000",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "errors/general",
      height: 200,
      marginBlock: "1000"
    }), /*#__PURE__*/_jsxs(T.Skeleton, {
      widths: ['40%', '70%'],
      heights: [32, 16],
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "heading-300",
        marginBlockStart: "600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.errorFallback.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: "1000",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.errorFallback.paragraph"
        })
      })]
    })]
  });
};